import en from "./en";
import ru from "./ru";
import vt from "./vt";

export function getLocalizations() {
  return {
    en: en,
    ru: ru,
    vt: vt
  };
}
